import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Transition, TransitionGroup } from 'react-transition-group'
import { ErrorBoundary } from '@sentry/react'

export const DrawerWrapper = observer(() => {
  const { drawersStore } = useRootStore()
  const stack = drawersStore.drawers

  return (
    <ErrorBoundary>
      <Transition unmountOnExit in={stack.length > 0} timeout={300}>
        <TransitionGroup component={null}>
          {stack.map(({ component: Component, props }, index: number) => (
            <Transition key={index} timeout={300} mountOnEnter unmountOnExit appear>
              {(state) => (
                <Component {...props} stackIndex={index} open={['exited', 'entered', 'entering'].includes(state)} />
              )}
            </Transition>
          ))}
        </TransitionGroup>
      </Transition>
    </ErrorBoundary>
  )
})
